"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styled_components_1 = require("styled-components");

var palette_1 = require("../constants/palette");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var ToastVariant;

(function (ToastVariant) {
  ToastVariant["Success"] = "success";
  ToastVariant["Danger"] = "danger";
  ToastVariant["Warning"] = "warning";
  ToastVariant["Info"] = "info";
})(ToastVariant = exports.ToastVariant || (exports.ToastVariant = {}));

var getVariantDetails = function getVariantDetails(variant) {
  if (variant === void 0) {
    variant = ToastVariant.Info;
  }

  var variantDetails;

  switch (variant) {
    case ToastVariant.Success:
      variantDetails = {
        primary: palette_1.default.green,
        secondary: palette_1.default.lightGreen,
        icon: free_solid_svg_icons_1.faCheckCircle
      };
      break;

    case ToastVariant.Danger:
      variantDetails = {
        primary: palette_1.default.red,
        secondary: palette_1.default.lightRed,
        icon: free_solid_svg_icons_1.faExclamationCircle
      };
      break;

    case ToastVariant.Warning:
      variantDetails = {
        primary: palette_1.default.yellow,
        secondary: palette_1.default.lightYellow,
        icon: free_solid_svg_icons_1.faExclamationTriangle
      };
      break;

    case ToastVariant.Info:
    default:
      variantDetails = {
        primary: palette_1.default.blue,
        secondary: palette_1.default.lightBlue,
        icon: free_solid_svg_icons_1.faInfoCircle
      };
      break;
  }

  return variantDetails;
};

var StyledToastContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 0 2px 6px 0 rgba(51, 51, 51, 0.31);\n  display: flex;\n  font-size: 12px;\n  font-weight: 500;\n"], ["\n  background-color: ", ";\n  box-shadow: 0 2px 6px 0 rgba(51, 51, 51, 0.31);\n  display: flex;\n  font-size: 12px;\n  font-weight: 500;\n"])), function (props) {
  return props.secondary;
});
var StyledToastIconContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  background-color: ", ";\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.primary;
});
var ContentContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 16px;\n  color: ", ";\n  ul {\n    list-style-type: disc;\n    li { margin-left: 20px; }\n  }\n"], ["\n  padding: 16px;\n  color: ", ";\n  ul {\n    list-style-type: disc;\n    li { margin-left: 20px; }\n  }\n"])), function () {
  return palette_1.default.black;
});

var ToastIconContainer = function ToastIconContainer(props) {
  return React.createElement(StyledToastIconContainer, __assign({}, props), React.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: props.icon,
    size: "2x",
    color: "white"
  }));
};

var Toast = function Toast(props) {
  var variantDetails = getVariantDetails(props.variant);
  return React.createElement(StyledToastContainer, __assign({}, variantDetails), React.createElement(ToastIconContainer, __assign({}, variantDetails)), React.createElement(ContentContainer, null, props.children));
};

exports.default = Toast;
var templateObject_1, templateObject_2, templateObject_3;